<template lang="pug">
.u-pad-h--4
  .c-bubble-chat-wrapper(:class="chatWrapperGroup")
    .c-bubble-chat.o-flag(:class="[chatSenderClass, chatBubbleWidthClass]")
      .o-flag__head(v-if="status === 'failed'")
        IcoAlertMinor.u-valign-middle
      //- Image Media Thumbnail
      template(v-if="type === 'image'")
        ImageThumbnail(:url="textChat" @media-thumbnail-click="onMediaThumbnailClick")
      //- Video Media Thumbnail
      template(v-else-if="type === 'video'")
        VideoThumbnail(:url="textChat" @media-thumbnail-click="onMediaThumbnailClick")
      //- Normal text body
      template(v-else)
        .c-bubble-chat-body(:class="[flagBodyClass, showMetaClass, groupMetaClass, bubbleBorderClass]" data-testid="bubble-chat-body")
          //- Special message template
          template(v-if="isSpecialMessage")
            template(v-if="specialMessageContent.type === 'generic'")
              p.c-bubble-chat-body__text(data-testid="bubble-chat-body-text") {{ specialMessageContent.text }}
            template(v-if="specialMessageContent.type === 'electric-token'")
              p.c-bubble-chat-body__text(data-testid="bubble-chat-body-text" :style="{ paddingBottom: 0 }") Berikut token listrik milik juragan:<br>
              p.c-bubble-chat-body__text.c-bubble-chat-body__text--bold(data-testid="bubble-chat-electric-token-content") {{ specialMessageContent.token }}
            template(v-if="specialMessageContent.type === 'phone-serial-number'")
              p.c-bubble-chat-body__text(data-testid="bubble-chat-body-text") Setelah Acha cek, paket data atau pulsa harusnya udah masuk dengan nomor #[span.c-bubble-chat-body__text--bold(data-testid="bubble-chat-phone-serial-number-content") SN {{ specialMessageContent.text }}.] Coba dicek, ya!
            template(v-if="specialMessageContent.type === 'rrn-found'")
              p.c-bubble-chat-body__text(data-testid="bubble-chat-body-text") Oke. Acha mau cek, apa bener nomor RRN di bukti bayarnya adalah #[span.c-bubble-chat-body__text--bold(data-testid="bubble-chat-rrn-content") {{ specialMessageContent.text }}?]
            template(v-if="specialMessageContent.type === 'url'")
              BlButtonAv(data-testid="bubble-chat-body-link-button" @click="redirectTo(specialMessageContent.url)" fullwidth) {{ specialMessageContent.text }}
          template(v-else)
            //- Normal Chat Text
            p.c-bubble-chat-body__text(v-if="textChat.length > 0 && !imgUrl.length" v-html="processedTextChat" data-testid="bubble-chat-body-text")
            //- Image Attachment
            template(v-if="imgUrl.length > 0 && isImgUrlRealImage")
              .c-bubble-chat-body__attachment(data-testid="bubble-chat-image-attachment")
                Lightbox(data-testid="bubble-chat-image-attachment-lightbox" :thumbnail="imgUrl" :images="[imgUrl]" alternate-text="Attachment")
            //- Non-Image Attachment
            template(v-if="imgUrl.length > 0 && !isImgUrlRealImage")
              div.c-bubble-chat-body__attachment-download(data-testid="bubble-chat-attachment" @click="onNonImageAttachmentClick(imgUrl)")
                IcoDocument.c-bubble-chat-body__attachment-download__icon
                div.c-bubble-chat-body__attachment-download__details
                  p(data-testid="bubble-chat-attachment-name") {{ imgName }}
                  p(data-testid="bubble-chat-attachment-size") {{ attachmentSize }}
      .c-bubble-chat-body__meta(v-if="showMeta")
        template(v-if="status !== 'failed'")
          span.c-bubble-chat-body__meta__time(v-show="shouldShowTimestamp && specialMessageContent.type !== 'url'" data-testid="meta-time") {{ timeString }}
        .c-bubble-chat-body__meta__resend(v-else @click="resendChat") Kirim ulang
        template(v-if="shouldShowAvatar && specialMessageContent.type !== 'url'")
          Avatar.mt-8(:nick="nick" data-testid="chat-avatar")
</template>

<script>
import { BlButtonAv } from '@bukalapak/bazaar-mweb';
import IcoAlertMinor from '@bukalapak/bazaar-visual/dist/components/IcoAlertMinor';
import IcoDocument from '@bukalapak/bazaar-visual/dist/components/IcoDocument';
import Lightbox from '~/components/shared/BLLightbox';
import Avatar from '~/components/chat/Avatar';
import ImageThumbnail from '~/components/chat/ImageThumbnail';
import VideoThumbnail from '~/components/chat/VideoThumbnail';

import { humanizeTimestamp } from '~/utils/date-helper';

export default {
  name: 'BubbleChat',
  components: {
    BlButtonAv,
    Lightbox,
    IcoAlertMinor,
    IcoDocument,
    Avatar,
    ImageThumbnail,
    VideoThumbnail,
  },
  props: {
    isMe: {
      type: Boolean,
      default: false,
    },
    imgUrl: {
      type: String,
      default: '',
    },
    imgName: {
      type: String,
      default: '',
    },
    imgSize: {
      type: Number,
      default: 0,
    },
    textChat: {
      type: String,
      default: '',
    },
    showMeta: {
      type: Boolean,
      default: false,
    },
    timestamp: {
      type: Number,
      default: 0,
    },
    nick: {
      type: String,
      default: '',
    },
    type: {
      type: String, // 'image' | 'video'
      default: '',
    },
    status: {
      // available status: sent, pending, failed
      type: String,
      default: '',
    },
    shouldShowTimestamp: {
      type: Boolean,
      default: false,
    },
    shouldShowAvatar: {
      type: Boolean,
      default: false,
    },
    chatIndex: {
      type: Number,
      default: 0,
    },
    messageLength: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    chatSenderClass() {
      let bubbleChatClass = `c-bubble-chat--${this.isMe ? 'right' : 'left'}`;
      if (this.imgUrl !== '' && this.isImgUrlRealImage) {
        bubbleChatClass += ' c-bubble-chat--image';
      }
      return bubbleChatClass;
    },

    /**
     * Make the bubble width full (100%) or normal
     * @returns {string}
     */
    chatBubbleWidthClass() {
      if (this.specialMessageContent?.type === 'url') {
        return 'c-bubble-chat--full-width';
      }
      return '';
    },

    flagBodyClass() {
      return `${this.status === 'failed' ? 'o-flag__body' : ''}`;
    },
    timeString() {
      return humanizeTimestamp(this.timestamp, '%hh%:%mi%');
    },
    statusIcon() {
      if (this.status === 'sent') {
        return 'ico_check';
      } else if (this.status === 'pending') {
        return 'ico_time_minor';
      }
      return '';
    },
    statusClass() {
      if (this.status === 'sent') {
        return 'c-bubble-chat-body__meta__icon--sent';
      } else if (this.status === 'pending') {
        return 'c-bubble-chat-body__meta__icon--pending';
      }
      return '';
    },
    showMetaClass() {
      if (this.showMeta && this.isMe) {
        return 'u-border-bottom-right-radius--0';
      } else if (this.showMeta && !this.isMe) {
        return 'u-border-bottom-left-radius--0';
      }
      return '';
    },
    groupMetaClass() {
      if (this.shouldShowTimestamp) return;
      return 'u-border-group';
    },

    /**
     * Decides if the bubble-chat-body should have border
     * @returns {string}
     */
    bubbleBorderClass() {
      if (this.specialMessageContent?.type === 'url') {
        return 'c-bubble-chat-body--no-border';
      }

      return '';
    },

    chatWrapperGroup() {
      if (this.shouldShowTimestamp) return;
      return 'u-mrgn-bottom--0';
    },
    processedTextChat() {
      // hack disini cukup nasty. replace disini biar client-send | server-send bisa sama
      return this.textChat
        .replace(/(<br>)/gm, '\n') // br ke newline
        .replace(/!\[(\w+)\]\((.*)/gm, '<img alt="$1" src="$2"/>')
        .replace(
          // process link
          /[^"#>](http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(\/\S*)?/gm,
          selectedString => `<a href="${selectedString}" target="_blank">${selectedString} </a>`
        )
        .replace(/\n/gm, '<br>'); // revert newline ke br
    },
    isLastChat() {
      return this.chatIndex === this.messageLength - 1;
    },

    /**
     * Checks if the incoming `textChat` has `[special-message]` tag
     * @returns {boolean}
     */
    isSpecialMessage() {
      return this.textChat?.includes('[special-message]');
    },

    /**
     * Extract the message content of '[special-message]' type of textChat
     * @returns {object}
     */
    specialMessageContent() {
      if (this.isSpecialMessage) {
        const mainPart = this.textChat?.split('[special-message]')[1]?.trim() || '{}';
        /**
         * Split by ','
         * Then iterate the items
         * example mainPart = '{ "type": "electric-token", "token": "1234-5678-8765-4321" }'
         */
        const messageContents = JSON.parse(mainPart);
        return messageContents;
      }

      return {};
    },

    /**
     * Checks if imgUrl prop value has a URL value of an image or not
     * such as: .pdf, .txt, .docs, .etc.
     * @returns {boolean}
     */
    isImgUrlRealImage() {
      const validImageExt = ['png', 'jpg', 'jpeg'];
      const imgExt = this.imgUrl?.split('.').pop();

      return validImageExt.includes(imgExt);
    },

    /**
     * Return actual size of the attachment file
     * @returns {string}
     */
    attachmentSize() {
      const sizeInKiloByte = Math.ceil(this.imgSize / 1000);
      return `${sizeInKiloByte} KB`;
    },
  },
  methods: {
    resendChat() {
      this.$emit('resend', this.$props);
    },
    toBr(str) {
      return str.replace(/\n/gm, '<br>');
    },

    /**
     * Handles event @thumbnail-click
     * Will emit media-thumbnail-click event, which will later be handled by MessageList.vue to show/hide MediaPreview
     * @param {object} - Value emitted from the ImageThumbnail or VideoThumbnail
     * @param {string} param.url
     * @param {string} param.mediaType
     */
    onMediaThumbnailClick({ url = '', mediaType = '' }) {
      this.$emit('media-thumbnail-click', { url, mediaType });
    },

    /**
     * Downloads the non-image attachment sent by agent when the user clicks the bubble
     * @param {string} url - url of the attacment, take this from `imgUrl` prop
     */
    onNonImageAttachmentClick(url = '') {
      window.open(url, '_blank');
    },

    /**
     * invoked when the user clicks a redirection button from a chat bubble
     * @param {string} url
     */
    redirectTo(url = '') {
      window.parent.location = url;
    },
  },
};
</script>

<style lang="scss">
$bubble-chat-max-width: 75%;

.c-bubble-chat {
  max-width: $bubble-chat-max-width;
  width: auto;

  &--full-width {
    max-width: none;
    width: 100%;
  }

  &-wrapper {
    overflow: hidden;
    margin-bottom: 8px;
  }

  &-body {
    background-color: #f5f5f5;

    &__text {
      font-size: 14px;
      padding: 8px 16px;
      margin-bottom: 0;

      &--bold {
        font-weight: bold;
      }
    }

    &__attachment {
      z-index: 209;
    }

    &__attachment-download {
      display: flex;
      padding: 16px 8px;

      &__details {
        padding: 0 8px;
        p:first-child {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 4px;
        }
        p:last-child {
          font-size: 13px;
          color: #8d8d8d;
        }
      }
    }

    &__link {
      text-decoration: none;
    }

    &__meta {
      text-align: right;
      font-size: 12px;
      margin-top: 8px;

      &__time {
        color: #999;
      }

      &__resend {
        color: #d71149;
        margin-left: 8px;
      }

      &__icon {
        margin-left: 8px;
        vertical-align: middle;

        &--sent {
          fill: #d71149;
        }
        &--pending {
          fill: #999;
        }
      }
    }
  }

  &--right {
    float: right;
  }

  &--image {
    width: 124px;
    height: 164px;
  }

  &--left {
    float: left;

    .c-bubble-chat-body {
      background-color: #fff;
      border: solid 1px #dddddd;

      &--no-border {
        border: 0;
      }

      &__meta {
        text-align: left;
      }
    }
  }

  &-body,
  &-body__attachment img {
    border-radius: 20px;
    min-height: 36px;
    min-width: 36px;
    width: auto;
  }
}

.u-border-bottom-right-radius--0 {
  border-bottom-right-radius: 0;
}

.u-border-group {
  border-radius: 20px !important;
}

.u-border-bottom-left-radius--0 {
  border-bottom-left-radius: 0;
}
</style>
